import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchCampaigns = createAsyncThunk('campaigns/fetch', async () => {
  const response = await api.get('/campaigns');
  return response.data;
});

export const createCampaign = createAsyncThunk('campaigns/create', async (data) => {
  const response = await api.post('/campaigns', data);
  return response.data;
});

export const sendCampaign = createAsyncThunk('campaigns/send', async ({ id, contactIds }) => {
  const response = await api.post(`/campaigns/${id}/send`, { contactIds });
  return response.data;
});

const campaignSlice = createSlice({
  name: 'campaigns',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaigns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.error = null;
      })
      .addCase(fetchCampaigns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Don't clear items on error, keep existing data
      })
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(sendCampaign.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendCampaign.fulfilled, (state, action) => {
        state.loading = false;
        // Update the campaign with new data
        const index = state.items.findIndex(c => c.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(sendCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default campaignSlice.reducer;
